import { render, staticRenderFns } from "./SelecaoNivelTpl.vue?vue&type=template&id=79c0710b&"
import script from "./SelecaoNivelTpl.vue?vue&type=script&lang=js&"
export * from "./SelecaoNivelTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports